import React, { MutableRefObject } from 'react';
import Form from 'devextreme-react/form';
import { Scrollable } from '@core/components';

type FormRef = MutableRefObject<unknown | null | undefined>;

interface ScrollableFormProps {
  formItems: any[];
  formData?: FormRef;
  formInstance?: FormRef;
  heightAuto?: boolean;
  onInitialized?: () => void;
  readOnly?: boolean;
}

const ScrollableForm = ({
  formItems,
  formData,
  formInstance,
  heightAuto,
  onInitialized,
  readOnly
}: ScrollableFormProps) => {
  const onFormInit = ({ component }: any) => {
    if (formInstance) {
      const instance = component.instance();
      formInstance.current = instance;
    }

    if (onInitialized) {
      onInitialized();
    }
  };

  const determineFormData = () => {
    if (formData) {
      return { formData };
    }

    return {};
  };
  return (
    <Scrollable heightAuto={heightAuto}>
      <Form
        {...determineFormData()}
        readOnly={readOnly}
        onInitialized={onFormInit}
        className="scrollable-form"
        colCount={1}
        items={formItems}
      />
    </Scrollable>
  );
};

export default ScrollableForm;
